export default function reload({ router }) {
  router.reload()
}
